import { inject } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

const checkAuth = async (): Promise<boolean> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const ok = await authService.restoreSession();
  if (ok && authService.isTenantSession()) {
    return true;
  }

  if (ok && authService.isPlatformSession()) {
    await router.navigateByUrl('/platform/dashboard');
    return false;
  }

  await router.navigateByUrl('/auth/login');
  return false;
};

export const tenantAuthGuard: CanActivateFn = () => checkAuth();
export const tenantAuthChildGuard: CanActivateChildFn = () => checkAuth();
